import $ from 'jquery'

function tutorialsShow($element, options) {
  // constructor
  function init() {
    SOPHIA.tutorial.id = options.packet_id;
    SOPHIA.tutorial.author_id = options.tutorial_author_id;

    SOPHIA.publisher.publishingState.setState(options.publishingState);

    if (SOPHIA.loggedIn()) {
      SOPHIA.initPingator({ target: { id: options.packet_id, type: 'tutorial' } });
    }

    $('.section').each(function() {
      SOPHIA.initTutorialSections($(this))
    });

    // Video Section gets initialized once. It get broken being iterated.
    if ($('.videojs-player').length) {
      SOPHIA.videoJsPlayer()
    }

    const $transcriptToggleLink = $('.collapse-toggle-title')
    $transcriptToggleLink.on('click', (e) => {
      e.preventDefault();
      expandCollapseTranscriptBlock($(e.target))
    })

    $(document).foundation();

    const $createAccountForm = $('#header-sign-up-form');

    if ($createAccountForm) {
      $createAccountForm.formMaterialDesign();
    }
  }

  // run constructor
  init();

  // PUBLIC METHODS

  return {};

}

function expandCollapseTranscriptBlock(el) {
  const $toggler = $(el).closest('.collapse-toggle-title');
  const $togglerIcon = $toggler.find('.collapse-toggle');
  const $block = $toggler.siblings('.video-transcription');
  const isMarkup = $(el).parents('.markup_section').length
  const sectionType = isMarkup ? "Markup" : "Video"
  let eventAction

  $block.stop(true,true);

  if ($block.hasClass('collapsed')) {
    expandTranscriptBlock($block, $togglerIcon);
    eventAction = 'expand'
  } else {
    collapseTranscriptBlock($block, $togglerIcon);
    eventAction = 'collapse'
  }

  SOPHIA.clickToggleForGA({
    el: $toggler,
    eventAction,
    moduleName: sectionType + ' Section',
    fieldType: 'drawer'
  })
}

function expandTranscriptBlock(block, icon) {
  icon.html('<i class="minus"></i>');

  block.slideDown('normal', () => {
    block.removeClass('collapsed');
  });
}

function collapseTranscriptBlock(block, icon) {
  icon.html('<i class="plus"></i>');

  block.slideUp('normal', () => {
    block.addClass('collapsed');
  });
}

// jQuery plugin method
$.fn.tutorialsShow = function (options) {
  return this.each(function () {
    var $this = $(this);

    // If not already stored, store plugin object in this element's data
    if (!$this.data('tutorialsShow')) {
      $this.data('tutorialsShow', tutorialsShow($this, options));
    }
  });
};
